/**
 * Skeleton loader for charge point details panel
 * Shown while loading new charge point/site data
 */
export function ChargePointSkeleton() {
  return (
    <div className="space-y-4 animate-pulse">
      {/* Availability Section Skeleton */}
      <div className="space-y-2">
        <div className="h-4 w-24 bg-ink/10 rounded"></div>
        <div className="h-20 bg-ink/5 rounded-lg"></div>
      </div>

      {/* Address Section Skeleton */}
      <div className="space-y-2">
        <div className="h-4 w-20 bg-ink/10 rounded"></div>
        <div className="space-y-2">
          <div className="h-4 w-full bg-ink/5 rounded"></div>
          <div className="h-4 w-3/4 bg-ink/5 rounded"></div>
        </div>
      </div>

      {/* Pricing Section Skeleton */}
      <div className="space-y-2">
        <div className="h-4 w-16 bg-ink/10 rounded"></div>
        <div className="h-24 bg-ink/5 rounded-lg"></div>
      </div>

      {/* Fees Section Skeleton */}
      <div className="space-y-2">
        <div className="h-4 w-32 bg-ink/10 rounded"></div>
        <div className="h-20 bg-ink/5 rounded-lg"></div>
      </div>

      {/* Action Buttons Skeleton */}
      <div className="space-y-2">
        <div className="h-12 w-full bg-ink/5 rounded-lg"></div>
        <div className="h-12 w-full bg-ink/5 rounded-lg"></div>
      </div>
    </div>
  );
}
